import { TranslateDirective } from './translate.directive';
import { TranslatePipe } from './translate.pipe';

/** import ใน standalone component: imports: [TranslateModule] */
export const TranslateModule = [TranslatePipe, TranslateDirective] as const;
